<div class="bg-white text-xs flex flex-col justify-center items-center pt-18 md:pt-6 lg:pt-6 pb-16 h-39 md:h-36 lg:h-36 relative">
  <div class="flex md:flex-row flex-col items-center px-8 md:gap-20 ">
    <div >
      <div>{{getText().disclaimer}}</div>
      <div [innerHTML]="getText().copyright"></div>
    </div>
    <div class="flex pt-1 md:pt-0 lg:pt-0 gap-6 ">
      <img 
      [src]="'images/equal-housing.png'" 
      alt="Equal housing opportunity logo" 
      class="h-15">
      <img 
      [src]="'images/ncua.png'" 
      alt="NCUA logo" 
      class="h-15">
    </div>
  </div>
  <a [routerLink]="['/configuration']" routerLinkActive="active" class="absolute right-0 bottom-0 cursor-pointer focus:border-gray-300 focus:ring-4 focus:outline-none"><img src="icons/gear.svg"/></a>
</div>